import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AboutComponent} from './about.component';
import {SharedImportsModule} from "../../../shared/modules/shared-imports.module";

@NgModule({
    imports: [
        SharedImportsModule
    ],
    declarations: [
        AboutComponent
    ],
    exports: [
        AboutComponent
    ]
})
export class AboutModule {
}



// WEBPACK FOOTER //
// /var/www/luvi/frontend/src/app/components/public/about/about.module.ts